export class StudentAnnouncementUpsertResponseModel {
	id: number;
}
